import { Controller } from "@hotwired/stimulus"
import $ from 'jquery'
import 'selectize/dist/js/selectize.min'

export default class extends Controller {
  static values = { url: String }

  connect() {
    $(this.element).selectize({
      valueField: 'id',
      labelField: 'text',
      searchField: ['text'],
      sortField: 'text',
      load: (query, callback) => {
        if (query.length < 2) return callback()
        return fetch(this.urlValue + '?term=' + encodeURIComponent(query))
          .then(r => r.json())
          .then(callback)
          .catch(() => callback())
      }
    })
  }

  disconnect() {
    if (this.element.selectize) {
      this.element.selectize.destroy()
    }
  }
}
